
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/email",
      function () {
        return require("private-next-pages/apps/email/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps/email"])
      });
    }
  